import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useTechnicianModel } from "../../technicianModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    const { descDetTotal, selectedDetRowKeys, rowsDescDetTotal, technicianDetailsExcel } = useTechnicianModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        technicianDetailsExcel()
    }
    const title = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={onEdit}
    >{Locale["export"]}</Button>
    const desc: IDescription[] = [
        {
            // label: "工时",
            label: Locale["Maintenance Man-hours"],
            value: selectedDetRowKeys.length === 0 ? descDetTotal.workHours : formatNum(rowsDescDetTotal.workHours),
            color: DescriptionColorEnum.red
        },
        {
            // label: "工时费",
            label: Locale["Total　Labor Cost"],
            value: selectedDetRowKeys.length === 0 ? descDetTotal.receivableAmount : formatNum(rowsDescDetTotal.receivableAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "维修台词",
            label: Locale["Maintenance Vehicle- times"],
            value: selectedDetRowKeys.length === 0 ? descDetTotal.number : formatNum(rowsDescDetTotal.number),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={title} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}